export default {
  btc: "#F6921C",
  eth: "#6D85E8",
  bnb: "#F1B835",
  dot: "#DB0D7C",
  ada: "#4DCDCC",
  usdt: "#239A74",
  xrp: "white",
  ltc: "white",
  link: "blue",
  bch: "#77B33F"
};
